import React from 'react';
import './YoutubePage.css';

/* Hand-drawn play-button icon */
function IconPlay() {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" style={{flexShrink: 0}}>
            <path
                d="M8,5 L8,23 L23,14 Z"
                fill="#222" stroke="#222" strokeWidth="1.5" strokeLinejoin="round"
            />
        </svg>
    );
}

/* Hand-drawn YouTube-style play icon (larger, for the page) */
function IconYoutube() {
    return (
        <svg width="72" height="52" viewBox="0 0 72 52" fill="none">
            <rect x="3" y="3" width="66" height="46" rx="10" stroke="#222" strokeWidth="2.5" fill="none"/>
            <path
                d="M28,15 L28,37 L48,26 Z"
                fill="#222" stroke="#222" strokeWidth="1.5" strokeLinejoin="round"
            />
        </svg>
    );
}

export default function YoutubePage() {
    const youtubeUrl = 'https://www.youtube.com/watch?v=woIaitMj4FM&list=PL8Ax_z5vzflyrjzmyYTdj-NqPcQcAkZ4W';

    return (
        <div className="youtube-page">
            <h2 className="youtube-page__title">Samuel, d'Émilie Tronche</h2>

            <div className="youtube-page__photo-frame">
                <img src="/setj.png" alt="Samuel — Emilie Tronche" className="youtube-page__photo"/>
            </div>

            <p className="youtube-page__text">
                Pour les connaisseurs vous aurez reconnus notre inspiration dans la création de ce site, pour les autres <br/>foncez écouter l'histoire de Samuel !
            </p>

            <a
                href={youtubeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="youtube-page__cta"
            >
                <IconPlay />
                Regarder la série
            </a>
        </div>
    );
}
